<template>
  <draggable
    :list="[]"
    :group="{ name: 'controls' }"
    v-bind="{ preventOnFilter: false }"
    filter="*"
    class="pbx-drop-area"
    @mousemove.native="setCursorPosition"
    @change="on_drop"
  >
    <slot></slot>
  </draggable>
</template>

<script>
  import Draggable from '@app/plugins/vuedraggable';
  import { mapActions } from 'vuex';
  import { BOX_SIZE } from '@/plugins/dnd-zone/utils';

  export default {
    components: {
      Draggable
    },

    methods: {
      ...mapActions('pbx/worksheets/form', ['addTemporaryItem', 'setCursorPosition']),

      on_drop: function({ added }, { originalEvent }) {
        const box_position_center = {
          x: originalEvent.layerX - BOX_SIZE / 2,
          y: originalEvent.layerY - BOX_SIZE / 2
        };

        if (added && added.element) {
          this.addTemporaryItem({
            ...added.element,
            position: box_position_center
          });
        }
      }
    }
  };
</script>

<style lang="scss">
  .pbx-drop-area {
    min-width: 4000px;
    min-height: 4000px;

    .sortable-ghost {
      display: none;
    }
  }
</style>
